'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createSvg = require('./utils/createSvg');

var _createSvg2 = _interopRequireDefault(_createSvg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createSvg2.default)(_react2.default.createElement(
  'g',
  null,
  _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z' })
), 'Sms');


//////////////////
// WEBPACK FOOTER
// ./~/material-react-icons/Sms.js
// module id = 855
// module chunks = 0